import { render, staticRenderFns } from "./CenterMenuBase.vue?vue&type=template&id=3240827b"
import script from "./CenterMenuBase.vue?vue&type=script&lang=ts"
export * from "./CenterMenuBase.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports